<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from '@/components/Page-header';
import appConfig from "../../../../../app.config";


/**
 * Form elements component
 */
export default {
 page: {
    title: "Copasst",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "Base de conocimiento",
          href: "/forms/general",
        },
        
        {
          text: "Instrucciones para documentar la matriz",
          active: true,
        },
      ],
      };
  },
  methods: {
    /**
     * Scrollspy
     */
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  

   
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title">Procedimiento matriz de identificación peligros del SG-SST</h4>

            <br>
            <b-row>
              <b-col cols="4">
                <b-list-group v-b-scrollspy:listgroup-ex>
                  <b-list-group-item href="#list-item-1"
                    >Proceso</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-2"
                    >Zona/Lugar</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-3"
                    >Actividad</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-4"
                    >Rutinaria </b-list-group-item
                  >
                  <b-list-group-item href="#list-item-5"
                    >Peligro </b-list-group-item
                  >
                  <b-list-group-item href="#list-item-6"
                    >Efectos posibles </b-list-group-item
                  >
                  <b-list-group-item href="#list-item-7"
                    >Controles existentes </b-list-group-item
                  >
                  <b-list-group-item href="#list-item-8"
                    >Evaluación del riesgo </b-list-group-item
                  >
                  <b-list-group-item href="#list-item-9"
                    >Criterios para establecer controles </b-list-group-item
                  >
                  <b-list-group-item href="#list-item-10"
                    >Medidas de intervención </b-list-group-item
                  >
                
                   <!--  <b-list-group-item href="#list-item-5"
                    >!.1.2</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-6"
                    >1.1.3</b-list-group-item
                  >-->
                  
                 
                </b-list-group>
              </b-col>

              <b-col cols="8">
                <div
                  id="listgroup-ex"
                  style="position: relative; overflow-y: auto; height: 430px">
                  <h4 id="list-item-1">Proceso</h4>
                  <p>Proceso de la Empresa en el que se presenta el riesgo (Los procesos son propios de cada Empresa). </p>
                  <h4 id="list-item-2">Zona/Lugar</h4>
                  <p>Sede o lugar de la Empresa en donde existe el riesgo. </p>
                  <h4 id="list-item-3">Actividad</h4>
                  <p>Durante cual actividad o labor se presenta el riesgo (Las actividades son propias de cada empresa)</p>
                  <h4 id="list-item-4">Rutinaria</h4>
                  <p>Si/No  Seleccionar de acuerdo a la periodicidad con la que se realiza la actividad. Ej: Para una Rutinaria panadería, amasar es una actividad rutinaria. En un taller mecánico, desmontar un motor es una actividad que puede no ser rutinaria, sino que se realiza a demanda. </p>
                  <h4 id="list-item-5">Peligro</h4>
                  <p><b>Descripción:</b> Describir el peligro que se tiene.  <br/> 
                    <b>Clasificación:</b> Clasificación del peligro de acuerdo a las clasificaciones de la "Tabla de Peligros" que se encuentra en el archivo de la matriz de riesgos. EJ: "Iluminación (Luz visible por exceso o deficiencia)" </p>
                  <h4 id="list-item-6">Efectos posibles</h4>
                  <p>Una vez ingresados la descripción y clasificación del peligro ¿Qué implicaciones puede llegar a tener el peligro descrito? Por ej: si el peligro fue: "Iluminación (Luz visible por exceso o deficiencia)" un efecto puede ser: Tener Cansancio visual. </p>
                  <h4 id="list-item-7">Controles existentes</h4>
                  <p><b>Fuente:</b> Si el control se ejerce en el origen del riesgo. Ej: Realizar mantenimiento preventivo a un motor.  <br/>
                    <b> Medio: </b>Las medidas de control se realizan entre la fuente y los individuos (personas) Ej: Apoyarse en máquinas mecánicas para trasladar objetos pesados.  <br/>
                    <b> Individuo:</b> Las medidas de control se aplican directamente en las personas. Ej: Uso de elementos de protección personal. </p>
                  <h4 id="list-item-8">Evaluación del riesgo</h4>
                  <p><b>Nivel de deficiencia:</b> Escala para validar qué tan deficiente está la Empresa (0= BAJO, 2 =MEDIO, 6 =ALTO, 10= MUY ALTO)  <br/>
                    <b>Nivel de exposición:</b> ( 4=CONTINUA, 3 = FRECUENTE, 2 =OCASIONAL, 1=ESPORADICA)  <br/>
                    <b>Nivel de consecuencia:</b> (100= MORTAL O CATASTROFICO, 60=MUY GRAVE, 25=GRAVE, s10=LEVE) </p>
                  <h4 id="list-item-9">Criterios para establecer controles</h4>
                  <p><b>Número de expuestos:</b> Ingresar valor numérico de 1 al número de empleados que tenga la empresa, indicando el número de colaboradores que se encuentran expuestos a ese riesgo.</p>
                  <h4 id="list-item-10">Medidas de intervención</h4>
                  <p>
                    Describir las medidas de intervención de acuerdo a la respuesta en la columna R "INTERPRETACIÓN DEL NIVEL DE RIESGO (NR)"  <br />
Si R = 1 --> Eliminación <br />
Si R = II, Sustitución y adoptar medidas de control de inmediato <br />
Nivel III: Controles <br/><br/><br/><br/><br/>
                  </p>
               
                  <!-- <h4  id="list-item-5">Item 5</h4>
                  <p>{{ text }}</p>
                   <h4 id="list-item-6">Item 6</h4>
                  <p>{{ text }}</p> -->
                  
                  <h4 hidden id="list-item-11"></h4>
                  <p> <br/><br/><br/><br/><br/><br/> <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/></p>
                   <h4 hidden id="list-item-11"></h4>
                  <p>{{ text }}</p>
                  <h4 hidden id="list-item-12"></h4>
                  <p>{{ text }}</p>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
